export default class SessionStorage {
    constructor() {
        this.init = this.init.bind(this);
        this.init();
    }

    init() {
        const clearSessionStorageElements = $('.clearSessionStorage');
        if (clearSessionStorageElements) {
            Array.prototype.slice.call(clearSessionStorageElements).forEach(function (item) {
                const isElementLink = item.nodeName.toLowerCase() == 'a';
                if (isElementLink) {
                    item.onclick = clear;
                }
                else {
                    clear();
                }
            });
        }

        function clear() {
            sessionStorage.removeItem("selectedEventsWithDeliveryTypes");
            sessionStorage.removeItem("selectedProductDeliveryTypeId");
            sessionStorage.removeItem("selectedSeasonsWithDeliveryTypes");
        };
    }
}
